
<section class="justify-center mx-6 sm:mx-16 h-screen">    
    <div class="flex">
      <input type="text" name="query" id="query" [(ngModel)]="search.query" class="w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-orange-600 sm:text-sm/6" placeholder="Frase a buscar">
      &nbsp;<input type="number" name="limit" id="limit" [(ngModel)]="search.limit" class="w-16 rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-orange-600 sm:text-sm/6" placeholder="Resultados">
      &nbsp;<a (click)="searchCollection()" class="rounded-md bg-white px-2.5 py-1.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:cursor-pointer hover:bg-gray-100 sm:block">Buscar<span class="sr-only"></span></a>
    </div>
    <br/>
    <ul role="list" class="divide-y divide-gray-100">
      <div *ngFor="let match of search.matches "> 
          <li class="grid items-center justify-between gap-x-6 py-3">
            <div><strong>Distancia: </strong>{{match.distance}} &nbsp; <strong>Fecha:</strong> {{match.metadata.timestamp}}</div>
            <div>[{{match.id}}] {{match.document}}</div>            
          </li>
        </div>
      </ul>
      <br/>
</section>